import { render, staticRenderFns } from "./CustomerServicePopup.vue?vue&type=template&id=2c704bb0&scoped=true&"
import script from "./CustomerServicePopup.vue?vue&type=script&lang=js&"
export * from "./CustomerServicePopup.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServicePopup.vue?vue&type=style&index=0&id=2c704bb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c704bb0",
  null
  
)

export default component.exports